import { canonicalLinks } from '@spotahome/soyuz/client';

const DEFAULT_LOCALE = 'en';
const routesWithValidLocaleCanonical = ['terms-and-conditions'];

const getCanonicalLinks = (req, locale, routeId) =>
  routesWithValidLocaleCanonical.includes(routeId)
    ? canonicalLinks.getCanonicalLinks(req, locale)
    : canonicalLinks.getCanonicalLinks(req, DEFAULT_LOCALE);

export const buildHeaders = (staticData, req) => {
  const { currentRoute, locale } = req;

  return {
    title: staticData.title,
    links: getCanonicalLinks(req, locale, currentRoute),
    metas: [
      { name: 'title', content: staticData.title },
      { name: 'description', content: staticData.metaDescription },
      { property: 'og:title', content: staticData.title },
      { property: 'og:description', content: staticData.metaDescription },
      {
        property: 'og:url',
        content: `https://www.spotahome.com/${currentRoute}`
      },
      { name: 'twitter:title', content: staticData.title },
      { name: 'twitter:description', content: staticData.metaDescription },
      {
        name: 'twitter:url',
        content: `https://www.spotahome.com/${currentRoute}`
      }
    ]
  };
};

export default {
  buildHeaders
};
